import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import AppStore from 'store/AppStore'
import ToastrAction from 'toastr/actions/ToastrAction'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import Job from '../../../dto/DtoJob'
import MultiContributorsAutocomplete from '../../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import ContributorDto from 'referencial/components/contributor/dto/ContributorDto'
import ImportQualityDefaultValue from '../ImportQualityDefaultValue'
import FractionAction from '../../../../referencial/components/fraction/actions/FractionAction'
import FractionDto from '../../../../referencial/components/fraction/dto/FractionDto'
import QualityAction from '../../../../quality/actions/QualityAction'
import SupportDto from '../../../../referencial/components/support/dto/SupportDto'
import Supportaction from '../../../../referencial/components/support/actions/SupportAction'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import CampaignDto from '../../../../campaign/dto/CampaignDto'
import { getImportMode, getIntegrationModesOpenDataQuality } from '../../../../utils/JobUtils'
import { hasValue } from '../../../../utils/NumberUtil'
import { Buffer } from 'buffer'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { nbPerPageLabelTiny } from '../../../../referencial/constants/ReferencialConstants'
import { CardTable } from '../../../../components/datatable/NewTable'
import NumberField from '../../../../components/forms/NumberField'
import { Button, Grid } from '@mui/material'
import IntegrationModeDialog from '../IntegrationModeDialog'
import RadioButtons from 'components/forms/RadioButtons'
import { darkBlue, mainWhite } from 'utils/constants/ColorTheme'
import { CITIES, DEPARTMENTS, STATIONS } from 'traitements/constants/TraitementConstants'
import { uniq } from 'lodash'

class SurfaceQualitometerPanel extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
        if (!this.props.fractions.length) {
            this.props.fetchFractions()
        }
        if (!this.props.supports.length) {
            this.props.fetchSupports()
        }
        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
        if (!this.props.qualityCampaigns.length) {
            this.props.fetchQualityCampaigns()
        }
        this.onChangeFilters({ stationsMode: STATIONS })
    }

    onDeleteCode = (s) => {
        const filters = this.getFilters()
        if (this.props.isEditMode) {
            if (filters.stationsMode === STATIONS) {
                const codes = this.props.job.parameters.parameters.filter(p => p != s.credentials)
                this.props.addCode(codes)
            } else {
                const list = (filters[filters.stationsMode] ?? []).filter(p => p !== s.credentials)
                this.onChangeFilters({ [filters.stationsMode]: list })
            }
        }
    }

    addCode = () => {
        const filters = this.getFilters()
        const code = this.refs.txtAddBssCode.value
        const exist = this.props.job.parameters.parameters.find(p => p.toLowerCase() == code.toLowerCase())
        if (this.props.isEditMode) {
            if (filters.stationsMode === STATIONS) {
                if (!code) {
                    AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
                } else if (exist) {
                    AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
                } else {
                    this.props.addCode([code, ...this.props.job.parameters.parameters])
                    this.refs.txtAddBssCode.value = ''
                }
            } else if (!code) {
                AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
            } else if (exist) {
                AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
            } else {
                this.onChangeFilters({ [filters.stationsMode]: [code, ...(filters[filters.stationsMode] ?? [])] })
                this.refs.txtAddBssCode.value = ''
            }
        }
    }


    onImportFile = e => {
        if (this.props.isEditMode) {
            const reader = new FileReader()
            const file = e.target.files[0]
            reader.onload = upload => {
                const split = upload.target.result.split(',')
                if (split[0].indexOf('text/csv') > 0 || split[0].indexOf('vnd.ms-excel') > 0) {
                    const buf = Buffer.from(split[1], 'base64').toString()
                    const codes = buf.replace(/;/g, '').split('\n').map(b => b.trim())
                    const filteredCodes = codes.filter((c) => c !== '')
                    const filters = this.getFilters()
                    if (filters.stationsMode === DEPARTMENTS) {
                        this.onChangeFilters({ departments: uniq([ ...(filters.departments ?? []), ...filteredCodes ]) })
                    } else if (filters.stationsMode === CITIES) {
                        this.onChangeFilters({ cities: uniq([ ...(filters.cities ?? []), ...filteredCodes ]) })
                    } else {
                        const codesToAdd = [...this.props.job.parameters.parameters, ...codes]
                        this.props.addCode(codesToAdd)
                    }
                } else {
                    AppStore.dispatch(ToastrAction.error(i18n.theSelectedFileMustBeInCsvFormat))
                }
                e.target.value = ''
            }
            reader.readAsDataURL(file)
        }
    }


    getStations = (filters) => {
        switch (filters.stationsMode) {
            case CITIES:
                return (filters.cities || []).map((v) => ({ credentials: v }))
            case DEPARTMENTS:
                return (filters.departments || []).map((v) => ({ credentials: v }))
            default:
                return this.props.job.parameters.parameters.map((v) => ({ credentials: v }))
        }
    }

    getFilters = () => {
        return this.props.job.parameters?.filters.length && hasValue(this.props.job.parameters?.filters[0]) ? JSON.parse(this.props.job.parameters?.filters[0]) : {}
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type))
        }
        return ''
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    clearAllStations = () => {
        const parameters = {
            ...this.props.job.parameters,
            parameters: [],
        }
        this.props.onChangeJob({ parameters })
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('DATA'))
            if (integration) {
                return [...data, integration]
            }
            return data
        })()
        this.props.onChangeDataTypes(newDataTypes)
    }

    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = parameters.dataTypes.filter(d => !d.includes('station'))
        if (integration) {
            dataTypes.push('stationIntegration')
        }
        this.props.onChangeDataTypes(dataTypes)
    }

    render() {
        const disabled = !this.props.isEditMode
        const filters = this.getFilters()
        const myData =this.getStations(filters)
        const codesTypes = [
            { code: STATIONS, name: i18n.stations },
            { code: CITIES, name: i18n.cities },
            { code: DEPARTMENTS, name: i18n.departments },
        ]
        return (
            <>
                <Grid container spacing={1} justifyContent='center' alignItems='baseline'>
                    <Grid size={4}>
                        <Select
                            value={getImportMode(this.getDataTypes('DATA'))}
                            options={getIntegrationModesOpenDataQuality()}
                            label={i18n.dataIntegration}
                            labelSpan={<IntegrationModeDialog />}
                            onChange={this.handleChangeDataIntegration}
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <NumberField
                            value={filters.recentHistoReplacePeriod ?? 6}
                            min={0}
                            title={i18n.replaceHistoPeriod}
                            onChange={ v => this.onChangeFilters({ recentHistoReplacePeriod: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <Checkbox
                            checked={!!this.getDataTypes('station')}
                            label={i18n.integrateStationInfo}
                            onChange={this.handleChangeStationIntegration}
                            disabled={ disabled }
                        />
                    </Grid>
                    {
                        !['DATA_REPLACE_RECENT_HISTO', 'DATA_REPLACE_HISTO'].includes(getImportMode(this.getDataTypes('DATA'))) && (
                            <Grid size={12}>
                                <h6 style={ { color: 'red' } }><span style={ { fontWeight: 'bold' } }>{i18n.payAttention}</span> : { i18n.badImportModeMessage }</h6>
                            </Grid>
                        )
                    }
                </Grid>
                <Grid container sx={{ alignItems: 'center' }}>
                    <Grid size={4}>
                        <Select
                            value={filters.campaignId}
                            keyValue='id'
                            options={this.props.qualityCampaigns.filter(cs => cs.campaignType === 3)}
                            label={i18n.campaign}
                            onChange={v => this.onChangeFilters({ campaignId: v })}
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <Input
                            value={ filters.parameterCodes }
                            title={ i18n.qualityParamters }
                            onChange={values => {
                                this.onChangeFilters({ parameterCodes: values })
                            }}
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <MultiContributorsAutocomplete
                            multiple
                            options={this.props.contributors}
                            values={filters.excludedProducers}
                            label={ i18n.producersExcluded }
                            onChange={values => {
                                this.onChangeFilters({ excludedProducers: values })
                            }}
                            disabled={ disabled }
                        />
                    </Grid>
                </Grid>
                <ImportQualityDefaultValue
                    defaultValue={filters}
                    onChange={obj => this.onChangeFilters(obj) }
                    isEditMode={this.props.isEditMode}
                />

                <Grid container mb={2} justifyContent='space-between' spacing={2}>
                    <Grid size={3}>
                        <label>{ i18n.importFile }</label>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            variant='contained'
                            component='label'
                            disabled={ disabled }
                            sx={{ padding: '5px', fontSize: '14px' }}
                        >
                            {i18n.importLabelStation}
                            <input
                                type='file'
                                accept='.csv'
                                hidden
                                onChange={this.onImportFile}
                            />
                        </Button>
                    </Grid>
                    <Grid size={3} />
                </Grid>
                <Grid container justifyContent='space-between' spacing={2}>
                    <Grid size={3}>
                        <label>{ i18n.addCredential }</label>
                    </Grid>
                    <Grid size={5}>
                        <input
                            id='txtAddBssCode' type='text'
                            placeholder={ i18n.BSSExample }
                            ref='txtAddBssCode'
                            disabled={ disabled }
                        />
                        <label className='tinyLabel'>{ i18n.theCodeMustBePresentInTheRepositoryAndDefinedByTheCode }</label>
                    </Grid>
                    <Grid size={4}>
                        <Grid container>
                            <Grid size={3} offset={1}>
                                <a
                                    className='waves-effect waves-light btn'
                                    onClick={ this.addCode }
                                    disabled={ disabled }
                                >
                                    { i18n.add }
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems='center' sx={{ padding: '10' }}>
                    <Grid size={3}>
                        <RadioButtons
                            elements={codesTypes}
                            selected={filters.stationsMode}
                            onChange={v => this.onChangeFilters({ stationsMode: v })}
                            title={i18n.schemeAgencyID} {...disabled}
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={12}>
                        <CardTable
                            headers={ ['credentials'] }
                            rows={ myData }
                            title={ filters.stationsMode === STATIONS ? i18n.credentials : i18n[filters.stationsMode] }
                            rowsPerPageOptions={ nbPerPageLabelTiny }
                            lineActions={[
                                { icon: 'delete', onClick: this.onDeleteCode, displayed: this.props.isEditMode },
                            ]}
                            actions={[{
                                icon: 'download',
                                onClick: () => exportFile({
                                    data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                                    titleFile: i18n.credentials,
                                }),
                                color: mainWhite,
                                tooltip: i18n.download,
                            }]}
                            exportButtonOnHeader
                            color={darkBlue}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
}

SurfaceQualitometerPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func,
    onChangeFilters: PropTypes.func,
    onChangeJob: PropTypes.func,
    supports: PropTypes.arrayOf(PropTypes.instanceOf(SupportDto)),
    fractions: PropTypes.arrayOf(PropTypes.instanceOf(FractionDto)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    fetchContributor: PropTypes.func,
    fetchSupports: PropTypes.func,
    fetchNetworks: PropTypes.func,
    fetchWatermasses: PropTypes.func,
    fetchQualifications: PropTypes.func,
    fetchStatus: PropTypes.func,
    fetchContributors: PropTypes.func,
    fetchFractions: PropTypes.func,
    qualityCampaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
    fetchQualityCampaigns: PropTypes.func,
}

const mapStateToProps = store => ({
    networks: store.NetworkReducer.networks,
    contributors: store.ContributorReducer.contributors,
    supports: store.SupportReducer.supports,
    fractions: store.FractionReducer.fractions,
    qualityCampaigns: store.QualityReducer.qualityCampaigns,
})

const mapDispatchToProps = {
    fetchContributors: ContributorAction.fetchContributors,
    fetchStatus: QualityAction.fetchStatus,
    fetchQualifications: QualityAction.fetchQualifications,
    fetchFractions: FractionAction.fetchFractions,
    fetchSupports: Supportaction.fetchSupports,
    fetchQualityCampaigns: CampaignAction.fetchQualityCampaigns,
}

export default connect(mapStateToProps, mapDispatchToProps)(SurfaceQualitometerPanel)
